import { CopyButton } from "@/components/ui/copy-button";
import { useActiveFileName } from "@/lib/hooks/useActiveFileName";
import { useActiveSnapshotId } from "@/lib/hooks/useActiveSnapshot";
import { useFilesystemStore } from "@/state/stores";
import { useShallow } from "zustand/shallow";
import { SourceCode } from "../SourceCode";

export function FileOutput() {
  const activeSnapshotId = useActiveSnapshotId();
  const fileName = useActiveFileName();
  const currentFile = useFilesystemStore(
    useShallow((state) => {
      const files =
        state.filesBySnapshotId[activeSnapshotId] || state.stagedFiles;
      return files.find((file) => file.path === fileName);
    }),
  );

  const isFileProcessing = currentFile?.status === "processing";

  return (
    <div className="grid grid-rows-[auto_1fr] h-full">
      <div className="flex items-center justify-between px-4 border-b h-10">
        <span className="font-mono text-sm">{currentFile?.path}</span>
        <CopyButton value={currentFile?.content || ""} />
      </div>

      {currentFile ? (
        <SourceCode
          key={`${activeSnapshotId}-${currentFile.path}`}
          content={currentFile.content}
          className="p-3 min-h-full"
          isStreaming={isFileProcessing}
          language={
            currentFile.path.endsWith(".json")
              ? "json"
              : currentFile.path.endsWith(".md")
                ? "md"
                : "ts"
          }
          enableOverflow
        />
      ) : (
        <div className="flex items-center justify-center h-full">
          <div>{fileName ? "File not found" : "No file selected"}</div>
        </div>
      )}
    </div>
  );
}
